module.exports = __webpack_public_path__ + "static/media/no-appointments.300142df.svg";